import './loader.scss';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default function Loader({ fullScreen, loaderSize, main }) {
  const styles = useMemo(() => (
    loaderSize ? {
      width: `${ loaderSize }px`,
      height: `${ loaderSize }px`,
    } : {}
  ), [loaderSize]);

  const classes = useMemo(() => classNames(
    'loader-wrapper',
    { 'loader-wrapper--full-screen': fullScreen },
    { 'loader-wrapper--full-screen--main': main },
  ), [fullScreen]);

  return (
    <div className={classes}>
      <div
        className='loader'
        style={styles}
      />
    </div>
  );
}

Loader.defaultProps = {
  fullScreen: false,
  loaderSize: 100,
  main: false,
};

Loader.propTypes = {
  fullScreen: PropTypes.bool,
  loaderSize: PropTypes.number,
  main: PropTypes.bool,
};
